
import axios from "axios";
import { FullURL, ToastContent } from "./views/factory/FactoryUtil";

const apiClient = axios.create({
    headers: {
        'content-type' : 'application/json'
    }
});

// # 包装请求
const request = (url, method = 'get', data = {}) => {
    let headers = {
        'content-type' : 'application/json'
    }
    let authorization = token()
    if(authorization) {
        headers['Authorization'] = authorization;
    }
    const isGet = method.toLowerCase() === 'get'
    return apiClient.request(url, {
        method : method,
        params : isGet ? data : null,
        data : isGet ? null : data,
        headers : headers,
        timeout : 15 * 1000
    });
}


 // # token 过期时间(1天 = 1440分钟)
 // # 1 天 服务器是3天
const expireTime = 1440 * 60 * 1000;
const token_expire_date_key = 'token_expire_date';

export const H5Login = (username, password) => {
    return new Promise((resolve) => {
        let code = 404;
        apiClient.post('auth/login', {
            'username' : username,
            'password' : password,
        }).then( response => {
            try {
                code = response.data.code
                // # 保存账号、密码、Token
                if(code === 200) {
                    let token = response.data.token
                    if(token) {
                        localStorage.setItem('username', username)
                        localStorage.setItem('password', password)
                        localStorage.setItem('token', token)
                        localStorage.setItem(token_expire_date_key, ((new Date()).getTime() + expireTime) + '')
                        const user = response.data.user
                        if(user) {
                            localStorage.setItem('userInfo', JSON.stringify(user))
                        }
                    } else {
                        code = 404
                    }
                } 
                resolve(code)
               
            } catch { 
                resolve(code)
            }
        }).catch((error) => {
            let {status = -1} = error || {}
            if(status === 509) {
                ToastContent('Access too fast')
                return
            }
            resolve(code)
        });
    });
};

const clearToken = () => {
    // # 令牌、过期时间、用户信息
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')
    localStorage.removeItem(token_expire_date_key)
}


export const userDisable = (token = '') => {
    return request('/api/users/disable', 'post', {token : token})
}

export const token = () => {
    try {

        // ======================================================
        // # 验证过期
        const value = localStorage.getItem(token_expire_date_key) || '0'
        const expireDate = new Date(parseInt(value, 10)).getTime()
        if((new Date()).getTime() >= expireDate) {
            clearToken()
            return undefined
        }
        // ======================================================

        const token = localStorage.getItem('token');
        if(token.length > 6) {
            return token
        }
    } catch {}
    return undefined
}

export const isLogin = () => {
    return token() !== undefined;
}

export const userInfo = () => {
    try {
        return JSON.parse(localStorage.getItem('userInfo')) || {}
    } catch {
        return {}
    }
}

export const avatarData = () => {
    const {avatar, avatar_data} = userInfo()
    if(avatar_data) {
        return avatar_data
    }
    else if(avatar) {
        return FullURL(avatar) || ''
    }
    return ''
}

export const updateCacheUserinfoName = (name) => {
    if(name) {
        const cacheUserInfo = userInfo()
        cacheUserInfo['name'] = name
        localStorage.setItem('userInfo', JSON.stringify(cacheUserInfo))
    }
}

export const updateCacheUserinfoAvatar = (base64) => {
    if(base64) {
        const cacheUserInfo = userInfo()
        cacheUserInfo['avatar_data'] = base64
        localStorage.setItem('userInfo', JSON.stringify(cacheUserInfo))
    }
}

export const logoutClear = () => {
    clearToken()
    localStorage.removeItem('username')
    localStorage.removeItem('password')
}

export const RegisterSendCode = (email, code = '') => {
    return request('/api/users/send_code', 'post', {email : email, code : code})
}

export const RegisterUser = (data) => {
    return request('/api/users/register', 'post', data)
}

export const ForgotSendCode = (email) => {
    return request('/api/users/send_code_forgot', 'post', {email : email})
}

export const UpdatePassword = (id, code, email, password) => {
    return request('/api/users/update_pwd', 'post', {
        id : id,
        code : code,
        email : email,
        password : password
    })
}

export const RequestTodayCandlestick = () => {
    return apiClient.get('/api/coins_market/list?page=0&limit=1000');
}

export const RequsetKline = (symbol, interval = 'MIN1', isUpdate = false) => {
    return apiClient.get('/api/coins_market/kline', {
        params : {
            'symbol' : symbol,
            'interval' : interval,
            'last' : isUpdate ? '1' : '0'
        }
    });
};

export const RequestAsstes = (type = '') => {
    return request('/api/user/gold/assets', 'get',  {type : type});
}

export const UpdateUserInfo = (avatar, name) => {
    const {uid} = userInfo()
    if(uid === undefined) {
        return
    }
    let data = {}
    if(avatar) {
        data['avatar'] = avatar
    }
    if(name) {
        data['name'] = name
    }
    if(Object.keys(data).length === 0) {
        return
    }
    data['uid'] = uid
    return request('/api/users/edit', 'put', data)
}

export const UpdateLoginPassword = (oldPwd, newPwd) => {
    let data = {}
    data['oldpwd'] = oldPwd
    data['newpwd'] = newPwd
    return request('/api/users/setpwd', 'post', data)
}

export const UpdatePaymentPassword = (loginPassword, paymentPassword) => {
    let data = {}
    data['lpwd'] = loginPassword
    data['ppwd'] = paymentPassword
    return request('/api/users/setppwd', 'post', data)
}

export const RequestMessage = () => {
    return request('/api/message/list', 'get', {page : '0', limit : '100'})
}

export const RequestNews = () => {
    return request('/api/news/list', 'get', {page : '0', limit : '100'})
}

export const RequestPrompt = () => {
    return request('/api/news/prompt', 'get')
}

export const FeedbackResortList = () => {
    return request('/api/feedback/resort_list', 'get')
}

export const FeedbackReplyList = (id) => {
    return request('/api/feedback/reply_list', 'get', {'fid' : id})
}

export const FeedbackResortMessage = (data = {}) => {
    return request('/api/feedback/resort', 'post', data)
}

export const FeedbackReplyMessage = (data = {}) => {
    return request('/api/feedback/reply_user', 'post', data)
}

export const chatData = () => {
    return request('/api/chat/user/message', 'get')
}

export const chatSend = (data = {}) => {
    return request('/api/chat/user_send', 'post', data)
}

export const chatListenReply= (data = {}) => {
    return request('/api/chat/user_listen_sys_reply', 'get', data)
}

export const RequestWallet = () => {
    return request('/api/currency_wallet/recharge')
}

export const PostRecharge = (data = {}) => {
    return request('/api/recharge/add', 'post', data)
}

export const RequestWithdraw = () => {
    return request('/api/withdraw/address')
}

export const PostWithdraw = (data = {}) => {
    return request('/api/withdraw/withdraw', 'post', data)
}

export const RequestMarketTrade = (symbol) => {
    return request('/api/coins_market/trade', 'get', {symbol : symbol})
}

export const RequestTradeRecord = (type, symbol) => {
    return request('/api/trade_record/symbol', 'get', {type: type, symbol : symbol})
}

export const RequestTransferHistory = () => {
    return request('/api/transfer/history')
}

export const SendTransfer = (data = {}) => {
    return request('/api/transfer/go', 'post', data)
}

export const RequestTradeSecondFutures = () => {
    return request('/api/trade_second/order')
}

export const SendTradeSecondFutures = (isUp = true, data = {}) => {
    return request(isUp ? '/api/trade_second/buy' : '/api/trade_second/sell', 'post', data)
}

export const RequestMarketDepth = (symbol) => {
    return request('/api/coins_market/depth', 'get', {symbol : symbol})
}

export const RequestTradeCoinDone = () => {
    return request('/api/trade_coins/done')
}

export const RequestTradeCoinUndone = (symbol = '') => {
    let data = {}
    if(symbol.length > 0) {
        data['symbol'] = symbol
    } else {
        data['other'] = ''
    }
    return request('/api/trade_coins/undone', 'get', data)
}

export const SendTradeCoin = (isBuy = true, data = {}) => {
    return request(isBuy ? '/api/trade_coins/buy' : '/api/trade_coins/sell', 'post', data)
}

export const RequestTradeCoinUndo = (data = {}) => {
    return request('/api/trade_coins/undo', 'post', data)
}

export const SendTradeFutures = (isBuy = true, data = {}) => {
    return request(isBuy ? '/api/trade_future/buy' : '/api/trade_future/sell', 'post', data)
}

export const RequestTradeFutures = () => {
    return request('/api/trade_future/order')
}

export const RequestTradeFuturesProfiting = () => {
    return request('/api/trade_future/profiting')
}

export const RequestTradeFuturesUndo = (id = '') => {
    return request('/api/trade_future/undo', 'post', {id : id})
}

export const CloseFutureOrder = (id = '') => {
    return request('/api/trade_future/close', 'post', {id : id})
}

export const RequestFavorites = () => {
    return request('/api/users/favorites/list')
}

export const RequestFavoriteSymbol = (symbol = '') => {
    return request('/api/users/favorites/symbol', 'post', {symbol : symbol})
}

export const RequestAppInfo = () => {
    return request('/api/app/app_info')
}